/*
 * Copyright (c) 2025. Bolmate B.V.
 */
import {IconName} from '@fortawesome/fontawesome-svg-core';
import './style/copyIcon.scss';

import React, {MouseEventHandler, useState} from 'react';
import classNames from 'classnames';
import {AwesomeIcon} from '@dvrd/dvr-controls';

interface Props {
    onClick?: MouseEventHandler;
    className?: string;
    copyIcon?: IconName;
    copiedIcon?: IconName;
    autoReset?: boolean;
    autoResetSeconds?: number;
}

export default function CopyIcon(props: Props) {
    const {onClick, className, copyIcon, copiedIcon, autoReset, autoResetSeconds} = props;
    const [clicked, setClicked] = useState(false);

    function _onClick(evt: React.MouseEvent) {
        setClicked(true);
        onClick?.(evt);
        startAutoReset();
    }

    function startAutoReset() {
        if (!autoReset) return;
        const seconds = autoResetSeconds ?? 3;
        window.setTimeout(() => {
            setClicked(false);
        }, seconds * 1000);
    }

    return (
        <div className={classNames('copy-icon', !!onClick && 'click', clicked && 'clicked', className)}
             onClick={_onClick} title='Kopiëren'>
            <AwesomeIcon name={copyIcon ?? 'copy'} className='action-icon copy'/>
            <AwesomeIcon name={copiedIcon ?? 'check'} className='action-icon copied'/>
        </div>
    )
}